var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen"},[_c('feather-icon',{staticClass:"text-body cursor-pointer",attrs:{"icon":"MaximizeIcon","size":"18"},on:{"click":_vm.action}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }